import { FC } from 'react'

type Props = {
  nombreTabla: string
}

const LogCeldaNombreTabla: FC<Props> = ({ nombreTabla }) => (
  <div className=' fw-bolder'>{nombreTabla}</div>


)

export { LogCeldaNombreTabla }
